import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageContent } from "@/hooks/usePageContent";
import ctaBuyImage from "@/assets/cta-buy.jpg";

const FinalCTASection = () => {
  const { getContent } = usePageContent({ pageKey: "home" });
  const heading = getContent("final_cta", "heading", "Let's Plan Your Next Move");
  const body = getContent(
    "final_cta",
    "body",
    "Get a clear plan and next steps tailored to your goals.",
  );
  const buttonLabel = getContent("final_cta", "button_label", "Book a Consultation");
  const buttonUrl = getContent("final_cta", "button_url", "/consultation");

  return (
    <section className="relative overflow-hidden py-16 md:py-20">
      <img
        src={ctaBuyImage}
        alt="Hadassah Homes consultation call to action"
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
        decoding="async"
        width={1600}
        height={900}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-black/40" />
      <div className="relative z-20 mx-auto max-w-wide px-5 md:px-12 text-center">
        <div className="mx-auto max-w-xl">
          <h2 className="font-headline text-3xl md:text-[3rem] lg:text-[3.65rem] text-white mb-6 leading-[1.1]">
            {heading}
          </h2>
          <p className="text-white/90 max-w-xl mx-auto mb-11 text-base md:text-lg leading-relaxed">
            {body}
          </p>
          <Button variant="gold" size="lg" className="gap-2.5 px-11 py-[1.1rem] text-base text-white shadow-[0_12px_30px_-14px_rgba(191,164,105,0.65)] transition-all duration-300 hover:-translate-y-px hover:shadow-[0_18px_40px_-14px_rgba(191,164,105,0.72)] md:px-12 md:py-[1.2rem]" asChild>
            <Link to={buttonUrl}>
              {buttonLabel}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
